import faker from 'faker';
import cloneDeep from 'lodash/cloneDeep';
import store from '@/store';
import server from '@/mock/server';
import seeders from '@/mock/data/seeders';
import dateAdapter from '@/helpers/dayjsAdapter';
import SocialMediaHandlerService from '@/services/SocialMediaHandler';

const { getters } = store;
const SYS_ADMIN_ROLE = getters['auth/SYS_ADMIN_ROLE'];

function getRandomInt(max) {
    return Math.floor(Math.random() * max + 1);
}

const {
    alerts,
    accountContexts,
    annotations,
    brandContexts,
    businessProfiles,
    dashboardTemplates,
    emails,
    feedItems,
    users,
    profileItems,
    profiles,
    teams,
    teamContexts,
    topics,
    rules,
    labels,
    layers,
    searchFolders,
    searchItems,
    webhooks,
    excludeTerms
} = seeders;

const { schema, db } = server;

for (const profileItem of profileItems) {
    server.create('profileItem', profileItem);
}

let recentContextId = 1;

const socialMediaService = new SocialMediaHandlerService();

for (const brandContext of brandContexts) {
    brandContext.id = recentContextId.toString();

    const createdBrandContext = server.create('brandContext', brandContext);

    createdBrandContext.update({
        icon: true,
        contextId: recentContextId.toString(),
        title: `${brandContext.category} On ${
            createdBrandContext.socialType
                ? `${socialMediaService.getNameById(brandContext.socialType)}`
                : 'All Networks'
        }`,
        section: 'brands',
        photoUrl: null
    });

    recentContextId++;
}

for (const teamContext of teamContexts) {
    teamContext.id = recentContextId.toString();

    const createdTeamContext = server.create('teamContext', teamContext);

    createdTeamContext.update({
        contextId: recentContextId.toString(),
        section: 'team_searches',
        photoUrl: null
    });

    recentContextId++;
}

for (const accountContext of accountContexts) {
    accountContext.id = recentContextId.toString();

    const createdAccountContext = server.create('accountContext', accountContext);

    createdAccountContext.update({
        contextId: recentContextId.toString(),
        section: 'my_searches',
        photoUrl: null
    });

    recentContextId++;
}

for (const profile of profiles) {
    server.create('profile', profile);
}

for (const team of teams) {
    server.create('team', team);
}

const relatedTeams = {};

for (const user of users) {
    const createdUser = server.create('user', user);

    if (user.role === SYS_ADMIN_ROLE) {
        continue;
    }

    const id = getRandomInt(db.teams.length - 1);
    const team = schema.teams.find(id);

    createdUser.update({ teams: [team] });

    if (relatedTeams[id]) {
        relatedTeams[id].push(createdUser);
    } else {
        relatedTeams[id] = [createdUser];
    }
}

for (const id in relatedTeams) {
    const team = schema.teams.find(id);

    team.update({ users: relatedTeams[id] });
}

for (const profile of businessProfiles) {
    server.create('businessProfile', profile);
}

for (const email of emails) {
    server.create('email', email);
}

for (const topic of topics) {
    server.create('topic', topic);
}

for (const rule of rules) {
    server.create('rule', rule);
}

for (const label of labels) {
    server.create('label', label);
}

for (const feedItem of feedItems) {
    server.create('feedItem', feedItem);
}

for (const folder of searchFolders) {
    server.create('searchFolder', folder);
}

for (const item of searchItems) {
    server.create('searchItem', item);
}

for (const webhook of webhooks) {
    server.create('webhook', webhook);
}

for (const alert of alerts) {
    server.create('alert', alert);
}

for (const layer of layers) {
    server.create('layer', layer);
}

let counter = 0;
const endDate = dateAdapter();
const startDate = dateAdapter.subtract(dateAdapter(cloneDeep(endDate)), 1, 'month');

let date = faker.date.between(startDate, endDate);

for (const annotation of annotations) {
    annotation.datetime = dateAdapter(date).format();

    const createdAnnotation = server.create('annotation', annotation);

    const id = getRandomInt(db.users.length - 1);

    const { firstName, lastName } = schema.users.find(id);

    // @NOTE backend should provide at least fullName to display it in modal
    createdAnnotation.update({
        user: { id, fullName: `${firstName} ${lastName}` }
    });

    counter++;

    if (counter % 2 === 0) {
        date = faker.date.between(startDate, endDate);
    }
}

for (const template of dashboardTemplates) {
    server.create('dashboardTemplate', template);
}

for (const excludeTerm of excludeTerms) {
    server.create('excludeTerm', excludeTerm);
}

server.db.dump();
